<style scoped lang="scss">
</style>
<template>
  <div class="page">
    <pinhigh-modal :on-close="useWebsite" v-if="redirecting" :close-button="false">
      <button class="button positive" @click.prevent="downloadApp">Download The App</button>
      <button class="button positive" @click.prevent="openApp">I Already Have The App</button>
      <button class="button boring" @click.prevent="useWebsite">Use Website</button>
    </pinhigh-modal>
  </div>
</template>
<script>
import platform from 'platform';

export default {
  name: 'AppRedirect',
  data() {
    return {
      redirecting: false,
      redirectPath: null,
      os: null
    };
  },
  created: function() {
    this.$store.dispatch('configNavigation', {leftEnabled: false});

    if (platform.os.toString().toLowerCase().match(/^ios/)) {
      this.os = 'ios';
    } else if (platform.os.toString().toLowerCase().match(/android/)) {
      this.os = 'android';
    }

    if (this.$route.query._r && this.os) {
      this.redirecting = true;
      this.redirectPath = this.$route.query._r;
    } else if (this.$route.query._r) {
      this.redirectPath = this.$route.query._r;
      this.useWebsite();
    } else {
      this.$router.replace({name: 'dashboard'});
    }
  },
  methods: {
    downloadApp() {
      if (this.os === 'ios') {
        window.location.href = 'https://itunes.apple.com/us/app/pinhigh-fantasy-golf/id1091329116';
      } else {
        window.location.href = 'https://play.google.com/store/apps/details?id=co.pinhigh';
      }
      window.location.href
    },
    openApp() {
      window.location.href = 'pinhigh://' + this.$route.query._r;
    },
    useWebsite() {
      window.location.href = this.redirectPath;
    }
  }
};
</script>
